import * as React from 'react';
import { Breadcrumbs } from '@grandvisionhq/common';
import { Container } from '@grandvisionhq/elements';
import { useFeatureToggles } from '@grandvisionhq/state';
import '@swc/helpers';
import { useBrPageContext } from '../../../context/context.js';
import '@bloomreach/react-sdk';
import '../../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/utils';
import '../../../utils/http-client.js';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../../operations/mutations/signup-promotion.js';
import '../../../operations/mutations/subscribe-newsletter.js';
import '../../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachProductRoutes } from '../../../hooks/use-bloomreach-product-routes.js';
import '../../../hooks/use-breakpoint-visibility.js';
import { createCategoryBreadcrumb } from './utils/create-category-breadcrumb.js';
import { createGraphProductBreadcrumb } from './utils/create-graph-product-breadcrumb.js';
import { createGraphSubCategoryBreadcrumb } from './utils/create-graph-subcategory-breadcrumb.js';

const CmsGraphProductBreadcrumbs = ({ variant , productType , brandName ,  })=>{
    const { isSubcategoryPlpLinkingDisabled  } = useFeatureToggles();
    const page = useBrPageContext();
    const [, productRoutes] = useBloomreachProductRoutes();
    const categoryRoute = productRoutes[productType];
    if (!categoryRoute) {
        console.warn('Could not find a product category route to render PDP breadcrumbs');
        return null;
    }
    const categoryBreadcrumb = createCategoryBreadcrumb(categoryRoute, page);
    const subCategoryBreadcrumb = isSubcategoryPlpLinkingDisabled ? null : createGraphSubCategoryBreadcrumb(categoryRoute, brandName, page, variant);
    const productBreadcrumb = createGraphProductBreadcrumb(categoryBreadcrumb, variant.displayName, brandName);
    const breadcrumbs = [
        categoryBreadcrumb,
        subCategoryBreadcrumb,
        productBreadcrumb
    ].filter(Boolean);
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Breadcrumbs, {
        pages: breadcrumbs
    }));
};

export { CmsGraphProductBreadcrumbs, CmsGraphProductBreadcrumbs as default };
//# sourceMappingURL=GraphProductBreadcrumbs.js.map
